import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

/** Same Firebase project as the API (FIREBASE_*). Phone/SMS on localhost: see README (authorized domains + Phone provider). */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);

const firebaseAuth = getAuth(app);
firebaseAuth.languageCode = "pt-BR";

export const auth = firebaseAuth;
